import React, { useEffect, useState } from "react";

export function ConfirmDialogHost() {
  const [state, setState] = useState({ open: false, message: "", resolve: null });

  useEffect(() => {
    window.confirmDialog = (message) =>
      new Promise((resolve) => {
        setState({ open: true, message, resolve });
      });
    return () => {
      delete window.confirmDialog;
    };
  }, []);

  if (!state.open) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/40 p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6 border border-slate-200">
        <p className="text-slate-800 mb-6">{state.message}</p>
        <div className="flex justify-end gap-2">
          <button
            type="button"
            className="px-4 py-2 rounded-lg border border-slate-300 text-slate-700 hover:bg-slate-50"
            onClick={() => {
              state.resolve?.(false);
              setState({ open: false, message: "", resolve: null });
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700"
            onClick={() => {
              state.resolve?.(true);
              setState({ open: false, message: "", resolve: null });
            }}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
